module.exports = __webpack_public_path__ + "img/1536205592.fc4d3920.jpg";